export function roundMoney(amount) {
  return String((Math.round(amount * 100) / 100).toFixed(2)).replace('.', ',') + ' €';
}
